import { addRequiredArrayRefinement } from '@repo/customer-registration-kit/common/validations/refinements';
import { z } from 'zod';

type FormatMessage = (descriptor: { id: string }) => string;

interface CreateCompanyActivityFormSchemaOptions {
  formatMessage: FormatMessage;
}

export function createCompanyActivityFormSchema({
  formatMessage,
}: CreateCompanyActivityFormSchemaOptions) {
  const requiredFieldMessage = formatMessage({
    id: 'generic.required-field.error',
  });

  return z
    .object({
      businessRelationships: z.array(z.string()).optional(),
      businessRelationshipsOther: z.string().optional(),
      incomingTransfersOrigin: z.array(z.string()).optional(),
      outgoingTransfersDestination: z.array(z.string()).optional(),
    })
    .superRefine((data, ctx) => {
      addRequiredArrayRefinement(
        ctx,
        'businessRelationships',
        data.businessRelationships,
        formatMessage
      );
      addRequiredArrayRefinement(
        ctx,
        'incomingTransfersOrigin',
        data.incomingTransfersOrigin,
        formatMessage
      );
      addRequiredArrayRefinement(
        ctx,
        'outgoingTransfersDestination',
        data.outgoingTransfersDestination,
        formatMessage
      );

      if (
        data.businessRelationships?.includes('other') &&
        !data.businessRelationshipsOther?.trim()
      ) {
        ctx.addIssue({
          code: 'custom',
          message: requiredFieldMessage,
          path: ['businessRelationshipsOther'],
        });
      }
    })
    .transform(data => ({
      businessRelationships: data.businessRelationships ?? [],
      businessRelationshipsOther: data.businessRelationshipsOther ?? '',
      incomingTransfersOrigin: data.incomingTransfersOrigin ?? [],
      outgoingTransfersDestination: data.outgoingTransfersDestination ?? [],
    }));
}

export type CompanyActivityFormValues = z.output<
  ReturnType<typeof createCompanyActivityFormSchema>
>;
export type CompanyActivityFormInputValues = z.input<
  ReturnType<typeof createCompanyActivityFormSchema>
>;
